import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

/**
 * Services preview grid for the public homepage. Shows up to 8 services
 * with name, description, price, duration. Click "View all" → booking wizard.
 */
export default function PublicServices({ services, settings, salonSlug }) {
  const title = settings.services_section_title || 'Our services';
  const subtitle = settings.services_section_subtitle ||
    'From BIAB and builder gel to gel manicures and lash treatments — book your favourite online.';

  return (
    <section id="services" className="py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-2xl font-semibold tracking-tight" style={{ fontFamily: 'Playfair Display' }}>{title}</h2>
          <Link to={`/book`}>
            <Button variant="ghost" size="sm">View all <ArrowRight size={14} className="ml-1" /></Button>
          </Link>
        </div>
        <p className="text-sm text-muted-foreground mb-6">{subtitle}</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.slice(0, 8).map((svc) => (
            <Card key={svc.id} className="p-4 rounded-2xl border bg-card shadow-[0_10px_30px_rgba(43,18,27,0.06)] card-hover">
              <h3 className="font-semibold text-sm mb-1" style={{ fontFamily: 'Playfair Display' }}>{svc.name}</h3>
              <p className="text-xs text-muted-foreground mb-3 line-clamp-2">{svc.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-primary">£{svc.price.toFixed(2)}</span>
                <span className="text-xs text-muted-foreground">{svc.duration_minutes} min</span>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
